import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { CertificationDomain } from 'shell/models/cerfication-domain';
import { objectToQueryString } from 'system/utils/object-to-query-string';

export const useModes = Object.freeze([
  {
    id: '0',
    value: 'Uso interno',
  },
  {
    id: '1',
    value: 'Modalità valida per Sportello ed Enti esterno',
  },
  {
    id: '2',
    value: 'Modalità valida solo per Sportello',
  },
  {
    id: '3',
    value: 'Modalità valida solo per Stato Civile',
  },
  {
    id: '4',
    value: 'Modalità valida solo per Elettorale',
  },
]);

export enum FlagTyDomain {
  Elettorale = '5',
}

interface UseModeProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>, item?: ItemVM) => void;
  error?: boolean;
  required?: boolean;
  label?: string;
  id?: string;
  params?: {
    tyDomain?: FlagTyDomain;
  };
}

const UseModeListComponent = ({
  disabled,
  onChange,
  value,
  error,
  params,
  label = 'Uso modalità',
  required,
  id = 'use-mode',
}: UseModeProps): React.ReactElement => {
  const [useModeList] = useHttpFetch<HttpResponseList<CertificationDomain>, Array<ItemVM>>(
    `${__CERTIFICATION_API_URL__}/certificazione/dominio-valori`,
    {
      onBootstrap: true,
      initialData: [],
      options: {
        params: {},
        paramsSerializer: () => {
          return objectToQueryString('filters', { tipoDominio: params?.tyDomain || '' });
        },
      },
      transformer: (response) => {
        return response.data.payload.list.map((el) => ({
          id: el.key?.codiceValore || '',
          value: el.testoValore || '',
        }));
      },
    }
  );

  const list = (useModeList.data || []) as Array<ItemVM>;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`${id}-label`}>
        {required ? `${label}` : label}
      </InputLabel>
      <PmiSelect
        labelId={`${id}-label`}
        id={id}
        name={id}
        value={value}
        label={required ? `${label}` : label}
        onChange={(event) =>
          onChange(
            event,
            list.find((el) => el.id === event.target.value)
          )
        }
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((code: ItemVM) => (
          <MenuItem key={`${code.id}-use-mode`} value={code.id}>
            {code.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

UseModeListComponent.displayName = 'List use mode component';

const UseModeList = memo(UseModeListComponent);

export default UseModeList as typeof UseModeListComponent;
